
















































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError } from '@/models/error/index';
import { IQuote, IQuotePackage, QuotePackageSectionEnum } from '@/models/quote';
import { AxiosError } from 'axios';

export default Vue.extend({
  name: 'QuotePackageDisplayListItem',

  props: {
    quote: Object as PropType<IQuote>
  },

  data() {
    return {
      QuotePackageSectionEnum,
      loading: false,
      error: null as ISystemError | null
    };
  },

  computed: {
    ...mapGetters({
      getQuotePackageById: 'quote/getQuotePackageById'
    }),

    quotePackage(): IQuotePackage {
      return this.getQuotePackageById(this.quote.package);
    }
  },

  watch: {
    quote: {
      handler(value) {
        if (value) {
          this.tryGetOrFetchQuotePackage();
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions({
      fetchQuotePackage: 'quote/fetchQuotePackage'
    }),

    async tryGetOrFetchQuotePackage(): Promise<IQuotePackage> {
      if (!this.quotePackage) {
        this.loading = true;
        try {
          await this.fetchQuotePackage(this.quote.package);
        } catch (e) {
          this.error = setErrorFromAxiosError(e as AxiosError);
        }
        this.loading = false;
      }
      return this.quotePackage;
    },

    getQuoteSectionPackageDocuments(sectionEnum: QuotePackageSectionEnum) {
      return this.quotePackage!.package_documents.filter(
        packageDocument => packageDocument.section == sectionEnum
      );
    }
  }
});
